export class CheckAgentCodeRequest {
  identityId?: string;
  employerId?: string;
  agentCode?: string;
}
export class EmployerCheckRequest {
  employerId?: string;
  agentCode?: string;
}
